import { InlineEmailCapture } from "@/components/InlineEmailCapture";
import { Reveal } from "@/components/Reveal";

export function FooterCta() {
  return (
    <section aria-label="Get started" className="border-t border-border/70 bg-ink py-16 text-cream">
      <Reveal>
        <div className="container mx-auto max-w-2xl text-center">
          <h2 className="text-display-md font-display text-cream">Your agent is ready</h2>
          <p className="mt-3 text-cream/75">
            Join 2,400+ teams. Free 14-day trial — no credit card.
          </p>
          <div className="mt-8">
            <InlineEmailCapture
              location="footer_cta"
              className="[&_input]:border-cream/30 [&_input]:bg-cream/10 [&_input]:text-cream [&_input]:placeholder-cream/50"
            />
          </div>
        </div>
      </Reveal>
    </section>
  );
}
